module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBold-WebS-99afeeed3dbf1eb8985e5fe84e71e55a.woff2";